import fetch from "isomorphic-fetch"

import { types } from 'components/Reports'

export default class API {
  static send({ start, stop, email, sid, type }) {

    const body = {
      start,
      stop,
      email,
    }

    let postType = ''

    if (sid && types.DETAILED === type) postType = `${ types.DETAILED }_${ types.DETAILED }`
    else if (sid && types.GENERAL === type) postType = types.DETAILED
    else if (!sid && types.DETAILED === type) postType = `${ types.DETAILED }_${ types.GENERAL }`
    else if (!sid && types.GENERAL === type) postType = types.GENERAL

    const request = new Request(`/api/report_request/${ postType }/${ sid }`, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    })

    return fetch(request)
  }
}
